<template>
    <div class="CourseSingupModalWarp">
        <!-- 显示报名 -->
        <el-dialog title="" :visible.sync="showSecondVisible" width="1200px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
            :close-on-click-modal='false' :append-to-body="true">
            <div class="singupdialogcenter">
                <div class="stepsBox">
                    <div class="line1"></div>
                    <div class="text">
                        <div class="registText">
                            <i class="el-icon-bank-card" style="color:#349cff"></i>
                        </div>
                        <div class="hittext">开票信息</div>
                    </div>
                    <div class="line2"></div>
                </div>
                <div class="singupForm">
                    <!-- label-position="left" -->
                    <el-form :model="formData" ref="formData" :rules='formRules' label-width="126px" class="demo-dynamic">
                        <div class="makeoutInfoBox">
                            <div class="header">开票信息
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="单位名称" prop="corpName">
                                        <el-input placeholder="请输入单位名称" v-model="formData.corpName"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="单位税号" prop="organizingCord">
                                        <el-input placeholder="请输入单位税号" v-model="formData.organizingCord"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="单位性质" prop="billnature">
                                        <el-radio-group v-model="formData.billnature" @change="billnatureFn">
                                            <el-radio label="小规模纳税人"></el-radio>
                                            <el-radio label="一般纳税人"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="开票种类" prop="billkind">
                                        <el-radio-group v-model="formData.billkind" @change="billkindFn">
                                            <el-radio label="增值税普通发票"></el-radio>
                                            <el-radio label="增值税专用发票" :disabled="billnatureValue=='小规模纳税人' ? true : false"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div v-if="billnatureValue=='一般纳税人'&&kindVal=='增值税专用发票'">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="单位电话" prop="billphone">
                                            <el-input placeholder="请输入单位电话" v-model="formData.billphone"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="单位地址" prop="billsite">
                                            <el-input placeholder="请输入单位地址" v-model="formData.billsite"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="开户行银行名称" prop="bankUserName">
                                            <el-input placeholder="请输入开户行银行名称" v-model="formData.bankUserName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="开户行银行账号" prop="bankName">
                                            <el-input placeholder="请输入开户行银行账号" v-model="formData.bankName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    
                                </el-row>
                            </div>

                            <div class="header">收票人信息</div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="收票人姓名" prop="linkman">
                                        <el-input placeholder="请输入收票人姓名" v-model="formData.linkman"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="收票人手机号" prop="phone">
                                        <el-input placeholder="请输入收票人手机号" v-model="formData.phone"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-row :gutter="0">
                                        <el-form-item label="所在地区" prop='area'>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.province" placeholder="省份" @change="areaonProvinces($event)" style="width:100%">
                                                    <el-option v-for="item in ProvinceArr" :key="item.provinceId" :label="item.province" :value="item.province"></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.town" placeholder="市区" style="width:100%" @change="areaonTowns($event)">
                                                    <el-option v-for="item in CityArr" :key="item.cityId" :label="item.city" :value="item.city"></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.county" placeholder="区县" style="width:100%" @change="areacountyFn($event)">
                                                    <el-option v-for="item in CountyArr" :key="item.areaId" :label="item.area" :value="item.area"></el-option>
                                                </el-select>
                                            </el-col>
                                        </el-form-item>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="详细地址" prop="acceptSite">
                                        <el-input placeholder="请输入详细地址" v-model="formData.acceptSite"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="接收邮箱" prop="billemail">
                                        <el-input placeholder="请输入接收邮箱" v-model="formData.billemail"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="缴费凭证" prop="payMentVoucher">
                                <el-upload id="imgupload" ref="imgupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="handleAvatarSuccess"
                                    :on-remove="handleRemove" :action="actionUrl" :headers="header" :limit="1" :file-list="imgfileList">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </div>
                        <div class="formBtnBox" v-if="billKeepStatus!=1">
                            <el-button @click="submitdraftFn" class="submitdraftBtn">保存</el-button>
                            <el-button type="primary" @click="submitForm('formData')" class="submitBtn" :loading="isloading">提交</el-button>
                            <el-button @click="offmodalFn" class="cancelBtn">取消</el-button>
                        </div>
                        <div class="formBtnBox" v-else>
                            <el-button @click="offmodalFn" class="cancelBtn">关闭</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import { formErrorScroll } from '@/utils'
export default {
    props: {
        leartrainData: {
            type: Object,
            default: null
        },
    },
    // watch: {
    //     secondVisible(oldVal, newVal) {
    //         // console.log(this.secondVisible,'secondVisible');
    //         // console.log(oldVal, newVal,'完善信息');
    //         this.showSecondVisible = this.secondVisible
    //     },
    //     deep: true,// 深度监听（例如对象中的数据）
    //     immediate: true//立即执行监听
    // },
    data() {
        return {
            showSecondVisible: true,
            active: 1,
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            header: null,
            // 报名表单
            formData: {
                // 开票所在地区
                areacity: {
                    province: null,
                    town: null,
                    county: null,
                },
                // billTypes: '',
                corpName: null,
                organizingCord: null,
                billkind: null,
                billnature: null,
                billsite: null,
                billphone: null,
                bankName: null,
                bankUserName: null,
                billemail: null,
                linkman: null,
                phone: null,
                acceptSite: null,//详细地址
                area: null,//所在地区
                payMentVoucher: '',//缴费凭证
            },
            imgfileList: [],
            formRules: {
                'corpName': [
                    { required: true, message: '单位名称不能为空', trigger: 'blur' }
                ],
                'organizingCord': [
                    { required: true, message: '单位税号不能为空', trigger: 'blur' }
                ],
                'billnature': [
                    { required: true, message: '请选择单位性质', trigger: 'change' }
                ],
                'billkind': [
                    { required: true, message: '请选择开票种类', trigger: 'change' }
                ],
                'billsite': [
                    {
                        required: true,
                        message: '请输入单位地址', trigger: 'blur'
                    },
                ],
                'billphone': [
                    {
                        required: true,
                        message: '请输入单位电话', trigger: 'blur',

                    },
                    // { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的联系人手机号码', }
                ],
                'bankName': [
                    {
                        required: true,
                        message: '请输入开户银行名称', trigger: 'blur'
                    },
                ],
                'bankUserName': [
                    {
                        required: true,
                        message: '请输入开户银行账号', trigger: 'blur'
                    },
                ],
                'billemail': [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                'linkman': [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                'phone': [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的手机号码', }
                ],
                'acceptSite': [
                    { required: true, message: '请输入详细地址', trigger: 'blur' },
                ],
                'area': [
                    { required: true, message: '请选择地区', trigger: 'change' }
                ],

                "payMentVoucher": [
                    { required: true, message: '不能为空', trigger: 'change' }
                ],


            },
            kindVal: null,
            billnatureValue: null,
            selectVal: null,
            newyear: '',
            nextyear: '',
            ProvinceArr: [],//省
            addressProvinceArr: [],
            CityArr: [],//市
            addressCityArr: [],
            CountyArr: [],
            isloading: false,
            billKeepStatus: "",
        }
    },
    mounted() {
        // 获取省的数据
        this.getProvinceFn()
        // 回填表单
        this.getyetFormFn()
    },
    methods: {
        // 省市县
        getProvinceFn() {
            httpService.getProvince().then(res => {
                if (res.code == 200) {
                    this.ProvinceArr = res.result
                    this.addressProvinceArr = res.result
                }
            })
        },
        // 开票所在地区
        // 选择省
        areaonProvinces(event) {
            let provinceId
            this.ProvinceArr.map(item => {
                if (event === item.province) {
                    return provinceId = item.provinceId
                }
            })
            // 改变省之后市变化
            this.formData.areacity.town = '';
            this.formData.areacity.county = '';
            this.getareaCityData(provinceId)
        },
        // 获取市
        getareaCityData(provinceId) {
            httpService.getCity(provinceId).then(res => {
                if (res.code == 200) {
                    this.CityArr = res.result
                    // 回显地址
                    if (this.formData.areacity.county) {
                        let cityId
                        this.CityArr.map(item => {
                            if (item.city === this.formData.areacity.town) {
                                return cityId = item.cityId
                            }
                        })
                        this.getCountyData(cityId)
                    }
                }
            })
        },
        // 选择市
        areaonTowns(event) {
            let cityId
            this.CityArr.map(item => {
                if (event === item.city) {
                    return cityId = item.cityId
                }
            })
            this.formData.areacity.county = '';
            this.getCountyData(cityId)
        },
        getCountyData(cityId) {
            httpService.getArea(cityId).then(res => {
                if (res.code == 200) {
                    this.CountyArr = res.result
                }
            })
        },
        // 选择区
        areacountyFn(event) {
            this.formData.area = `${this.formData.areacity.province},${this.formData.areacity.town},${this.formData.areacity.county}`
        },
        // 报名表单
        submitForm(formName) {
            let payMentVoucher
            if (this.imgfileList.length != 0) {
                this.imgfileList.forEach(item => {
                    if (item.response) {
                        payMentVoucher = item.response.result
                    } else {
                        payMentVoucher = item.name
                    }
                })
                this.formData.payMentVoucher = payMentVoucher
            }
            if (!payMentVoucher) {
                this.$message.error('请按要求上传缴费凭证');
                return
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isloading = true

                    this.formData.auditResult = 2
                    if (Array.isArray(this.formData.area)) {
                        this.formData.area = this.formData.area.join(',')
                    }
                    // this.formData.trainId = this.leartrainData.trainId
                    let newdataform = JSON.parse(JSON.stringify(this.formData))
                    delete newdataform.areacity
                    httpService.commitPayMentVoucher(newdataform).then(res => {
                        if (res) {
                            this.isloading = false
                            if (res.code == 200) {
                                this.$message({
                                    message: '开票信息提交成功',
                                    type: 'success'
                                });
                                this.getyetFormFn()
                                sessionStorage.setItem('downloadFile', res.result)
                                // this.$emit('update:isShow', false)
                                if (!this.isCustom) this.$destroy(this.$emit('changeShowBill', false)) // 销毁当前组件
                            } else {
                                this.$message.error(res.message);
                            }
                        }
                    })
                } else {
                    this.$nextTick(() => {
                        formErrorScroll()
                    })
                    return false;
                }
            });
        },
        // 存为草稿
        submitdraftFn() {
            // this.formData.status = 0//0草稿
            let payMentVoucher
            if (this.imgfileList.length != 0) {
                this.imgfileList.forEach(item => {
                    if (item.response) {
                        payMentVoucher = item.response.result
                    } else {
                        payMentVoucher = item.name
                    }
                })
                this.formData.payMentVoucher = payMentVoucher
            } else {
                this.formData.payMentVoucher = ""
            }
            this.formData.auditResult = 7
            if (Array.isArray(this.formData.area)) {
                this.formData.area = this.formData.area.join(',')
            }
            // this.formData.trainId = this.leartrainData.trainId
            let newdataform = JSON.parse(JSON.stringify(this.formData))
            delete newdataform.areacity
            httpService.commitPayMentVoucher(newdataform).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    if (!this.isCustom) this.$destroy(this.$emit('changeShowBill', false)) // 销毁当前组件
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        // 回填表单
        getyetFormFn() {
            httpService.getCommitBillAndPay(this.leartrainData.leaderPersonId ? this.leartrainData.leaderPersonId : null).then(res => {
                if (res.code == 200) {
                    // delete res.result.leaderResourceWayVo
                    res.result.areacity = {
                        province: '',
                        town: '',
                        county: '',
                    }
                    // 开票信息
                    // if (res.result.busBillInfoVo) {
                    this.billnatureValue = res.result.billnature
                    this.kindVal = res.result.billkind
                    if (res.result.area) {
                        res.result.area = res.result.area.split(',')
                        res.result.areacity.province = res.result.area[0]
                        res.result.areacity.town = res.result.area[1]
                        res.result.areacity.county = res.result.area[2]
                    } else {
                        res.result.areacity.province = '';
                        res.result.areacity.town = '';
                        res.result.areacity.county = '';
                    }
                    // res.result.busBillInfoBo = res.result
                    // } else {
                    //     res.result.busBillInfoBo = {
                    //         // billTypes: '',
                    //         corpName: '',
                    //         organizingCord: '',
                    //         billkind: '',
                    //         billnature: '',
                    //         billsite: '',
                    //         billphone: '',
                    //         bankName: '',
                    //         bankUserName: '',
                    //         billemail: '',
                    //         linkman: '',
                    //         phone: '',
                    //         acceptSite: '',//详细地址
                    //         area: '',//所在地区
                    //         payMentVoucher: '',
                    //     }
                    // }
                    // delete res.result.busBillInfoVo
                    if (res.result.payMentVoucher) {
                        let filelist = res.result.payMentVoucher.split(',');
                        filelist = filelist.map((imgSrc, index) => {
                            return {
                                url: srcUrl + imgSrc,
                                uid: index,
                                name: imgSrc
                            };
                        });
                        this.imgfileList = filelist
                    }
                    this.formData = res.result
                    this.billKeepStatus = res.result.billKeepStatus
                    // 所在地區
                    if (this.formData.areacity.town) {
                        let provinceId
                        this.ProvinceArr.map(item => {
                            if (item.province === this.formData.areacity.province) {
                                return provinceId = item.provinceId
                            }
                        })
                        this.getareaCityData(provinceId)
                    }
                    if (this.leartrainData != null) {
                        this.$nextTick(() => {
                            if (this.imgfileList.length > 0) {
                                this.$refs.imgupload.$el.firstChild.nextSibling.style.display = 'none'
                            }
                            // DOM 更新了
                            this.$refs["formData"].clearValidate()
                        })
                    }
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 单位性质
        billnatureFn(value) {
            this.billnatureValue = value
            if (this.kindVal == '增值税专用发票' && value == '小规模纳税人') {
                this.formData.billkind = '增值税普通发票'
            }
        },
        billkindFn(value) {
            this.kindVal = value
        },
        // 关闭表单
        offmodalFn() {
            // this.$emit('update:isShow', false)
            this.$emit('changeShowBill', false)
            if (!this.isCustom) this.$destroy(this.$emit('changeShowBill', false)) // 销毁当前组件
        },
        handleAvatarSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.imgfileList = fileList
                if (this.imgfileList.length > 0) {
                    document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
                }
            }
        },
        // 删除
        handleRemove(file, fileList) {
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
    }

}
</script>
<style lang="less" scoped>
// 课程相关
.dialogWarp {
	.singupdialogcenter::-webkit-scrollbar {
		width: 8px;
		/*height: 4px;*/
	}
	.singupdialogcenter::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	.singupdialogcenter::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	/deep/.singupdialogcenter {
		// padding: 17px 0px 0px 0px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 640px;
		overflow-y: auto;
		.courseBox1 {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			padding-bottom: 32px;
			border-bottom: 1px solid #dddddd;
			margin-bottom: 20px;
			.courseinfo {
				margin: 0 100px;
				font-size: 16px;
				line-height: 54px;
				color: #333333;
				.text {
					font-size: 16px;
					margin-right: 20px;
					line-height: 54px;
					color: #a6a9b7;
				}
			}
		}
		/deep/.el-checkbox__inner {
			border-radius: 50%;
		}
		.stepsBox {
			width: 80%;
			margin: 10px auto 0 auto;
			display: flex;
			flex-direction: row;
			align-items: center;
			.line1,
			.line2 {
				width: 422px;
				height: 2px;
				background: #448df7;
				margin-bottom: 36px;
			}
			.text {
				display: flex;
				flex-direction: column;
				align-items: center;
				color: #448df7;
				.registText {
					font-size: 20px;
					font-weight: bold;
					margin: -8px 0 10px 0;
				}
				.hittext {
					font-size: 14px;
				}
			}
		}
		.singupForm {
			width: 100%;
			.singupInfowarp {
				// padding-bottom: 32px;
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				// padding: 0 82px;
			}
			.singupInfobox {
				// padding-bottom: 32px;
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				padding: 0 50px;

				.header {
					margin-bottom: 12px;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
					}
				}
				// .honor {
				// 	// margin-left: 20px;
				// 	position: relative;
				// 	&::before {
				// 		position: absolute;
				// 		top: 16px;
				// 		left: -10px;
				// 		// margin-right: 4px;
				// 		color: #ff4d4f;
				// 		font-size: 16px;
				// 		font-family: SimSun, sans-serif;
				// 		line-height: 1;
				// 		content: '*';
				// 	}
				// }
				.btnwarp {
					font-size: 16px;
					// line-height: 54px;
					display: flex;
					flex-direction: row;
					justify-content: center;

					.icon {
						margin-right: 5px;
					}
					.addbtn {
						color: #0083ff;
						margin: 0 20px;
						cursor: pointer;
					}
					.deletebtn {
						color: #ff3c3c;
						margin: 0 20px;
						cursor: pointer;
					}
				}
			}
			.header {
				font-size: 18px;
				line-height: 54px;
				color: #333333;
				.education {
					font-size: 16px;
					line-height: 54px;
					color: #999999;
					padding-left: 6px;
				}
			}
			.educationInfoBox {
				.header {
					margin-left: 48px;
				}
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				// padding: 0 0px 30px 0px;
			}
			.makeoutInfoBox {
				// border-bottom: 1px solid #dddddd;
				margin-bottom: 0px;
				padding: 0 50px 30px 50px;
				.header {
					font-size: 18px;
					line-height: 54px;
					color: #333333;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
						padding-left: 6px;
					}
				}
			}

			.formBtnBox {
				display: flex;
				fill-opacity: row;
				justify-content: center;
				.submitBtn {
					width: 152px;
					height: 40px;
					background: #349cff;
					margin: 0 20px;
				}
				.submitdraftBtn {
					width: 152px;
					height: 40px;
					background: #52ca9c;
					margin: 0 20px;
					color: #fff;
				}
				.cancelBtn {
					width: 152px;
					height: 40px;
					border: 1px solid #a6a9b7;
					border-radius: 5px;
					margin: 0 20px;
				}
			}
		}
	}
	.yearbox {
		font-size: 15px;
		line-height: 40px;
		color: #a6a9b7;
		&::before {
			position: absolute;
			top: 12px;
			left: 0px;
			// margin-right: 4px;
			color: #ff4d4f;
			font-size: 16px;
			font-family: SimSun, sans-serif;
			line-height: 1;
			content: '*';
		}
	}
	.deteleIcon {
		font-size: 21px;
		cursor: pointer;
		color: red;
		line-height: 40px;
		margin-left: 4px;
	}
}
// 默认当前激活步骤显示的是黑色，这里修改显示为蓝色
::v-deep .el-step__head.is-process {
	color: #1890ff !important; // 圆圈中数字
	border-color: #1890ff !important; // 圆圈
}
::v-deep .el-step__title.is-process {
	color: #1890ff !important; // 圆圈下的标题文本
}
:v-deep .el-step__head.is-success {
	color: rgb(52, 158, 250);
	border-color: rgb(52, 158, 250);
}
::v-deep .el-step__title.is-success {
	font-weight: bold;
	color: rgb(52, 158, 250);
}
::v-deep .el-step__head is-finish {
	color: rgb(52, 158, 250);
}
</style>


